/**
 * Slug spellings used across imports/admin (frattoli vs crognaleto__frattoli).
 * Mirrors backend/utils/frazione_poi.py for client-side query building.
 */
const FRAZIONE_SLUG_ALIASES = {
  "campli:paganoni": ["pagannoni", "campli__pagannoni"],
  "campli:pagannoni": ["paganoni", "campli__paganoni"],
  "crognaleto:nerito": ["crognaleto__nerito"],
  "crognaleto:crognaleto__nerito": ["nerito"],
  "mosciano-sant-angelo:convento": ["mosciano-sant-angelo__convento"],
  "mosciano-sant-angelo:mosciano-sant-angelo__convento": ["convento"],
  "mosciano-sant-angelo:montone": ["mosciano-sant-angelo__montone"],
  "mosciano-sant-angelo:mosciano-sant-angelo__montone": ["montone"],
  "mosciano-sant-angelo:selva-alta": ["mosciano-sant-angelo__selva-alta"],
  "mosciano-sant-angelo:mosciano-sant-angelo__selva-alta": ["selva-alta"],
};

/** QR legacy / client senza village_slug (es. PUT /admin/frazioni/nerito). */
const GLOBAL_FRAZIONE_SLUG_ALIASES = {
  nerito: ["crognaleto__nerito"],
  crognaleto__nerito: ["nerito"],
};

export function frazioneSlugVariants(frazioneSlug, villageSlug) {
  const raw = (frazioneSlug || "").trim();
  if (!raw) return [];
  const out = [];
  const add = (s) => {
    const v = (s || "").trim();
    if (v && !out.includes(v)) out.push(v);
  };
  add(raw);
  const bare = raw.includes("__") ? raw.split("__").slice(-1)[0] : raw;
  add(bare);
  const vs = (villageSlug || "").trim();
  if (vs && !raw.includes("__")) add(`${vs}__${raw}`);
  for (const key of [raw, bare]) {
    for (const alias of FRAZIONE_SLUG_ALIASES[`${vs}:${key}`] || []) {
      add(alias);
      if (vs) add(`${vs}__${alias}`);
    }
    if (!vs) {
      for (const alias of GLOBAL_FRAZIONE_SLUG_ALIASES[key] || []) {
        add(alias);
      }
    }
  }
  return out;
}

/** Match a requested slug (e.g. crognaleto__nerito) to a row from the admin list. */
export function resolveFrazioneOpenSlug(requested, frazioni, villageSlug = null) {
  const raw = String(requested || "").trim();
  if (!raw) return null;
  const list = Array.isArray(frazioni) ? frazioni : [];
  if (list.some((f) => f.slug === raw)) return raw;
  const variants = frazioneSlugVariants(raw, villageSlug);
  const match = list.find((f) => variants.includes(f.slug));
  return match?.slug || raw;
}

/** Ensure village/comune scope is sent with frazione filters (backend expands variants). */
export function withFrazioneScope(params = {}) {
  const p = { ...params };
  const village = (p.village_slug || p.comune_id || "").trim();
  if (p.frazione_slug && village) {
    if (!p.village_slug) p.village_slug = village;
    if (!p.comune_id) p.comune_id = village;
  }
  return p;
}
